/** Generated from recipes/route-props.json. Candidate only. */
export const ROUTE_PROP_TEMPLATES = {
  'coastal_fallen_log': {
    'kind': 'fallen_log',
    'name': 'coastal fallen log',
    'frame': {
      'w': 250,
      'h': 80
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'coastal_split_log': {
    'kind': 'fallen_log',
    'name': 'coastal split log',
    'frame': {
      'w': 180,
      'h': 55
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'moor_fallen_log': {
    'kind': 'fallen_log',
    'name': 'moor fallen log',
    'frame': {
      'w': 120,
      'h': 38
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'moor_dead_bracken': {
    'kind': 'dead_bracken',
    'name': 'moor dead bracken',
    'frame': {
      'w': 76,
      'h': 98
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'moor_wind_bracken': {
    'kind': 'dead_bracken',
    'name': 'moor wind bracken',
    'frame': {
      'w': 68,
      'h': 88
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'moor_sparse_bracken': {
    'kind': 'dead_bracken',
    'name': 'moor sparse bracken',
    'frame': {
      'w': 80,
      'h': 92
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'causeway_tide_pool': {
    'kind': 'tide_pool',
    'name': 'causeway tide pool',
    'frame': {
      'w': 620,
      'h': 78
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'causeway_silt_pool': {
    'kind': 'tide_pool',
    'name': 'causeway silt pool',
    'frame': {
      'w': 520,
      'h': 70
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'causeway_shingle_pool': {
    'kind': 'tide_pool',
    'name': 'causeway shingle pool',
    'frame': {
      'w': 460,
      'h': 70
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'moor_mist_shelf': {
    'kind': 'mist_shelf',
    'name': 'moor mist shelf',
    'frame': {
      'w': 300,
      'h': 96
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'moor_split_mist_shelf': {
    'kind': 'mist_shelf',
    'name': 'moor split mist shelf',
    'frame': {
      'w': 320,
      'h': 98
    },
    'band': 'vegetation',
    'attachment': 'ground'
  },
  'moor_low_mist_shelf': {
    'kind': 'mist_shelf',
    'name': 'moor low mist shelf',
    'frame': {
      'w': 260,
      'h': 80
    },
    'band': 'vegetation',
    'attachment': 'ground'
  }
} as const;
export type RoutePropTemplate = keyof typeof ROUTE_PROP_TEMPLATES;
